/**
 * If the font name is the same for all themes, this helps automatically prefix
 * the font with the theme, allowing for easier automatic theme switching.
 */
export const addFontThemePrefix = (selectedTheme, value) => {
    switch (selectedTheme) {
        case 'dark':
            return value.startsWith('darkTheme.')
                ? value
                : `darkTheme.${value}`;
        case 'light':
        default:
            return value;
    }
};
